import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './scss/about.scss';

document.addEventListener('DOMContentLoaded', () => {
	gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

	ScrollSmoother.create({
		wrapper: 'smooth-wrapper',
		content: 'smooth-content',
		smooth: 1,
		effects: true,
	});
});
